module.exports = __webpack_public_path__ + "img/credit-card.f02b5408.svg";